import {Model} from 'backbone';
import TargetSiteModel from './targetSiteModel';
import TargetSectionCollection from '../../collections/common/targetSectionCollection';

export default Model.extend({
    idAttribute: 'uuid',
    url: '',
    defaults: {
        site: null,
        sections: null,
    },
    blacklist: ['id'],
    initialize(modelJSON) {
        const model = Object.assign({}, modelJSON);

        this.set('site', new TargetSiteModel(model.site || {}));
        this.set('sections', new TargetSectionCollection(model.sections || []));

        if (model) {
            // in case they are null, false, or undefined
            delete model.site;
            delete model.sections;
            this.set(model);
        }
    },
    getDomain() {
        return this.get('site').get('url');
    },
    getSectionPath() {
        const sections = this.get('sections');

        if (sections.length === 1) {
            return sections.at(0).get('navigationPath');
        }

        return '';
    },
    getFullPath() {
        return this.getDomain() + this.getSectionPath();
    },
    cloneWithoutSections() {
        const data = this.toJSON();
        delete data.sections;
        return new this.constructor(data);
    },
});
